import { logofaded, coverImage } from "../../assets/images/images";
import Footer from "../../components/Footer/Footer";
import Topbar from "../../components/Topbar/Topbar";
import "./ForgotPassword.css";

import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import API from "../../API";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from 'react-i18next';
import {
  FaEnvelope, FaKey, FaArrowLeft, FaExclamationCircle, FaPlaneDeparture,
  FaEnvelopeOpenText, FaLock, FaShieldAlt
} from "react-icons/fa";

export default function ForgotPassword() {
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    if (i18n.language === lng) return;
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
    window.location.reload();
  };
  const isFr = i18n.language === 'fr';
  const isAr = i18n.language === 'ar';
  const isRTL = isAr;
  /* Pre-fill the email from `?email=` so users coming from the
     "Forgot password?" link inside their account don't have to retype it. */
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get("email") || '');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
    setErrorMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setLoading(true);

    try {
      const response = await API.post(`/auth/request-password-reset/`, { email });
      if (response.status === 201) {
        window.location.href = '/login';
      }
    } catch (error) {
      console.error("Reset password error:", error);
      if (error.response) {
        setErrorMessage(error.response.data.message || t("forgotpassword.error_message"));
      } else {
        setErrorMessage(t("forgotpassword.error_message"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Page_login" dir={isRTL ? "rtl" : "ltr"}>
      <Topbar />

      <div className="auth-langbar" role="group" aria-label="language">
        <button type="button" className={`auth-langbtn ${isFr ? 'active' : ''}`} onClick={() => changeLanguage('fr')} aria-pressed={isFr}>FR</button>
        <button type="button" className={`auth-langbtn ${isAr ? 'active' : ''}`} onClick={() => changeLanguage('ar')} aria-pressed={isAr}>AR</button>
      </div>

      <main className="auth-shell">
        <aside
          className="auth-brand"
          style={{ backgroundImage: `url(${coverImage})` }}
        >
          <div className="auth-brand__scrim" />
          <div className="auth-brand__content">
            <div className="auth-brand__row">
              <div className="auth-brand__logo">
                <img src={logofaded} alt="Protour" />
              </div>
              <h2 className="auth-brand__heading">{t("forgotpassword.brand_heading")}</h2>
            </div>
            <p className="auth-brand__sub">{t("forgotpassword.brand_sub")}</p>

            <ul className="auth-features">
              <li>
                <span className="auth-features__ico"><FaEnvelopeOpenText /></span>
                <div>
                  <strong>{t("forgotpassword.feature_inbox_title")}</strong>
                  <span>{t("forgotpassword.feature_inbox_sub")}</span>
                </div>
              </li>
              <li>
                <span className="auth-features__ico"><FaLock /></span>
                <div>
                  <strong>{t("forgotpassword.feature_access_title")}</strong>
                  <span>{t("forgotpassword.feature_access_sub")}</span>
                </div>
              </li>
              <li>
                <span className="auth-features__ico"><FaShieldAlt /></span>
                <div>
                  <strong>{t("forgotpassword.feature_secure_title")}</strong>
                  <span>{t("forgotpassword.feature_secure_sub")}</span>
                </div>
              </li>
            </ul>
          </div>
        </aside>

        <section className="auth-form-wrap">
          <div className="auth-card">
            <div className="auth-card__head">
              <span className="auth-pill"><span className="auth-pill__dot"><FaKey /></span> {t("forgotpassword.pill")}</span>
              <h1 className="auth-card__title">{t("forgotpassword.title")}</h1>
              <p className="auth-card__sub">{t("forgotpassword.card_sub")}</p>
            </div>

            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="auth-field">
                <label className="auth-label">
                  <FaEnvelope className="auth-label__ico" />
                  <span>{t("forgotpassword.email_label")}</span>
                </label>
                <input
                  className="auth-input"
                  placeholder={t("forgotpassword.email_placeholder")}
                  type="email"
                  name="email"
                  value={email}
                  onChange={handleChange}
                  required
                />
              </div>

              {errorMessage && (
                <div className="auth-banner auth-banner--err">
                  <FaExclamationCircle />
                  <p>{errorMessage}</p>
                </div>
              )}

              <button type="submit" className="auth-btn auth-btn--primary" disabled={loading}>
                {loading ? (
                  <ClipLoader color={"#fff"} loading={loading} size={18} />
                ) : (
                  <>
                    <FaKey /> {t("forgotpassword.submit_button")}
                  </>
                )}
              </button>
            </form>

            <p className="auth-foot">
              <a className="auth-home" href="/login">
                <FaArrowLeft /> {t("forgotpassword.login_link")}
              </a>
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
